import { FC } from 'react';
import colors from 'styles/_colors.module.scss';

type Props = {
  color?: string;
  size?: number;
};
const DataSearchIcon: FC<Props> = ({ color = colors['--label'], size = 30 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26.25 8.75C26.25 11.5114 21.2132 13.75 15 13.75C8.7868 13.75 3.75 11.5114 3.75 8.75M26.25 8.75C26.25 5.98858 21.2132 3.75 15 3.75C8.7868 3.75 3.75 5.98858 3.75 8.75M26.25 8.75V13.75M3.75 8.75V15M3.75 15V21.25C3.75 23.6295 7.49003 25.6208 12.5 26.1261M3.75 15C3.75 17.3795 7.49003 19.3708 12.5 19.8761"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24.9686 24.9686C24.1769 25.7603 23.0831 26.25 21.875 26.25C19.4588 26.25 17.5 24.2912 17.5 21.875C17.5 19.4588 19.4588 17.5 21.875 17.5C24.2912 17.5 26.25 19.4588 26.25 21.875C26.25 23.0831 25.7603 24.1769 24.9686 24.9686ZM24.9686 24.9686L27.5 27.5"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default DataSearchIcon;
